import { render, staticRenderFns } from "./Input_Upload_s3Centralizado.vue?vue&type=template&id=23fc0b70&scoped=true"
import script from "./Input_Upload_s3Centralizado.vue?vue&type=script&lang=js"
export * from "./Input_Upload_s3Centralizado.vue?vue&type=script&lang=js"
import style0 from "./Input_Upload_s3Centralizado.vue?vue&type=style&index=0&id=23fc0b70&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fc0b70",
  null
  
)

export default component.exports